import { quintInOut } from 'svelte/easing';

export default function inversefade(
  node: Element,
  { opacity = 1, delay = 0, duration = 500, easing = quintInOut }
) {
  return {
    delay,
    duration,
    easing,
    css: (t: number, u: number) => {
      return `
        opacity: ${u * opacity}; 
        `;
    }
  };
}
